import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://veonlkxiiaboouvnsieu.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZlb25sa3hpaWFib291dm5zaWV1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY2MDQ3NDAsImV4cCI6MjA3MjE4MDc0MH0.UWZ5OMPMhzS4jNiGOPcPxu_5ah-HUkiru7d__4DNZvc';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage
  }
});

export { SUPABASE_URL, SUPABASE_ANON_KEY };
